import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_serpent-vault/artifacts/55baktdh_Monzal%20sin%20logo%20atras.png";

export const Logo = ({ size = 36, withText = false, className = "" }) => {
  // withText kept for API compatibility; the brand image already includes the wordmark.
  return (
    <div className={`flex items-center ${className}`} data-testid="monzal-logo">
      <img
        src={LOGO_URL}
        alt="MONZAL"
        style={{ height: size * 1.6, width: "auto" }}
        className="object-contain select-none"
        draggable="false"
      />
    </div>
  );
};

export default Logo;
